import {TodayGreeting} from '@/ts/types/component/today-page';

// Greeting bands for the Upcoming tile (IPD-2976 10.3): morning 04:00–11:59,
// afternoon 12:00–16:59, evening 17:00–03:59.
const MORNING_STARTS_AT_HOUR = 4;
const AFTERNOON_STARTS_AT_HOUR = 12;
const EVENING_STARTS_AT_HOUR = 17;

/**
 * Which band the given local time falls in.
 *
 * The evening band is the one that wraps midnight, so it can only be expressed as "at or
 * after 17:00, OR before 04:00". Writing it as a plain range is the bug this shape avoids:
 * `hour >= 17 && hour < 4` never matches anything.
 *
 * The time comes from the caller rather than from `new Date()` inside, so the boundaries are
 * testable and the function stays pure.
 */
export function resolveTodayGreeting(now: Date): TodayGreeting {
  const hour = now.getHours();
  if (hour >= EVENING_STARTS_AT_HOUR || hour < MORNING_STARTS_AT_HOUR) {
    return TodayGreeting.evening;
  }
  if (hour >= AFTERNOON_STARTS_AT_HOUR) {
    return TodayGreeting.afternoon;
  }
  return TodayGreeting.morning;
}

/**
 * Copy key per band. Every one takes a `name` parameter: the design greets by first name in
 * all three, so a band without a name has no design and the tile must always supply one.
 */
export const todayGreetingKey: Record<TodayGreeting, string> = {
  [TodayGreeting.morning]: 'today_greeting_morning',
  [TodayGreeting.afternoon]: 'today_greeting_afternoon',
  [TodayGreeting.evening]: 'today_greeting_evening',
};
